(() => {
  const formatMoney = (amount, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency
      }).format(amount / 100);
    } catch (_error) {
      return `${(amount / 100).toFixed(2)} ${currency}`;
    }
  };

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const select = section.querySelector('[data-variant-select]');
    const variantsNode = section.querySelector('[data-product-variants]');
    const button = section.querySelector('[data-add-to-cart]');
    const price = section.querySelector('[data-product-price]');

    if (!select || !variantsNode || !button || !price) return;

    let variants;
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (_error) {
      return;
    }

    select.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === select.value);
      if (!variant) return;

      const currency = document.documentElement.dataset.currency || 'USD';
      price.textContent = formatMoney(variant.price, currency);
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'Add to cart' : 'Sold out';

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    });
  });

  document.querySelectorAll('[data-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const slides = carousel.querySelectorAll('[data-carousel-slide]');
    const previous = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    const progress = carousel.querySelector('[data-carousel-progress]');

    if (!track || !slides.length || !previous || !next || !progress) return;

    const getStep = () => {
      const slide = slides[0];
      const styles = window.getComputedStyle(track);
      return slide.getBoundingClientRect().width + parseFloat(styles.columnGap || styles.gap || 0);
    };

    const update = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      const index = Math.min(slides.length, Math.max(1, Math.round(track.scrollLeft / getStep()) + 1));
      progress.textContent = `${String(index).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    };

    previous.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const headerShell = document.querySelector('.site-header-shell');

  if (headerShell) {
    const updateHeader = () => {
      headerShell.classList.toggle('is-scrolled', window.scrollY > 24);
    };

    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  }

  const editorialWall = document.querySelector('[data-editorial-wall]');

  if (editorialWall) {
    const photos = editorialWall.querySelectorAll('[data-editorial-photo]');
    const desktopMotion = window.matchMedia('(min-width: 721px)');
    let activePhoto = null;
    let wallFrame;

    const updateEditorialWall = () => {
      const viewportCenter = window.innerHeight / 2;
      let closest = null;
      let closestDistance = Infinity;

      if (reduceMotion || !desktopMotion.matches) {
        activePhoto?.classList.remove('is-centered');
        activePhoto = null;
        return;
      }

      photos.forEach((photo) => {
        const rect = photo.getBoundingClientRect();

        if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;

        const distance = Math.abs(rect.top + rect.height / 2 - viewportCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closest = photo;
        }
      });

      if (closest === activePhoto) return;

      activePhoto?.classList.remove('is-centered');
      closest?.classList.add('is-centered');
      activePhoto = closest;
    };

    const requestEditorialWallUpdate = () => {
      if (wallFrame) return;
      wallFrame = window.requestAnimationFrame(() => {
        wallFrame = null;
        updateEditorialWall();
      });
    };

    window.addEventListener('scroll', requestEditorialWallUpdate, { passive: true });
    window.addEventListener('resize', requestEditorialWallUpdate);
    desktopMotion.addEventListener('change', requestEditorialWallUpdate);
    updateEditorialWall();
  }
})();
